import { useCallback } from "react";
import ModalBasicLayout from "./ModalBasicLayout";
import TemplateProduce from "../../pages/Templates/TemplateProduce";
import { useTemplatesModals } from "../../contexts/templatesModalsContext";
import { useTranslationApp } from "../../lib/i18next";
import { TEMPLATES_PRODUCE_TITLE } from "../../i18n/keysTranslations";

const ModalTemplateProduce = ({
  modalOpen,
  onCloseModal,
  templateID = "",
  produceID = "",
}) => {
  const { t } = useTranslationApp();
  const { openTemplatesList } = useTemplatesModals();

  const onBackToList = useCallback(() => {
    onCloseModal();
    openTemplatesList();
  }, [onCloseModal, openTemplatesList]);

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullScreen={true}
      maxWidth={false}
      fullWidth={true}
      hasTitle={false}
      ariaLabel={t(TEMPLATES_PRODUCE_TITLE)}
      sxContent={{
        py: 0,
        px: 0,
        height: "100vh",
        maxHeight: "100vh",
        overflow: "auto",
      }}
      sxPaper={{
        height: "100vh",
        maxHeight: "100vh",
      }}
    >
      <TemplateProduce
        key={`${templateID}-${produceID}`}
        initialTemplateID={templateID}
        initialProduceID={produceID}
        onBackToList={onBackToList}
      />
    </ModalBasicLayout>
  );
};

export default ModalTemplateProduce;
